webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_scrollAnimation__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_navigation__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["scrollTop"] = scrollTop;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIe", function() { return isIe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return isMobile; });




$(document).ready(function () {
	jQuery.noConflict();
	// A P P L I C A T I O N     C O D E
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_navigation__["a" /* navigationEvents */])();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_scrollAnimation__["a" /* scrollAnimation */])();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_forms__["a" /* default */])();
	$('.pre-loader').fadeOut();
});

$(document).on('mousewheel DOMMouseScroll touchmove scroll', function () {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_scrollAnimation__["b" /* interiaScroll */])();
});

function scrollTop() {
	if (typeof pageYOffset != 'undefined') {
		//most browsers except IE before #9
		return pageYOffset;
	} else {
		var B = document.body; //IE 'quirks'
		var D = document.documentElement; //IE with doctype
		D = D.clientHeight ? D : B;
		return D.scrollTop;
	}
}
var isIe = navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == "Netscape" && navigator.appVersion.indexOf('Edge') > -1;
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = forms;
var required;
var email;
var current;

function forms() {
	$('body').on({
		'focus': function () {
			current = $(this);
			required = $(this).closest('.gfield_contains_required').length;
			email = $(this).closest('.ginput_container_email').length;
			if (current.val() === "") {
				toggleActive(current);
			}
		},
		'blur': function () {
			if (current.val() === "" && required) {
				toggleActive(current);
				current.addClass('error');
				return;
			}
			if (current.val() === "" && !required) {
				toggleActive(current);
			}
			if (current.val() !== "" && email) {
				var valid = validateEmail(current.val());
				if (!valid) {
					current.addClass('error');
					return;
				}
				current.removeClass('error');
			} else {
				current.removeClass('error');
			}
		}
	}, 'input').on({
		'click': function () {
			var form = $(this).closest('form');
			var hasErrors = form.find('.error').length;
			var hasEmptyRequired = form.find('.gfield_contains_required').find('input').val() === "";
			if (hasErrors || hasEmptyRequired) {
				generateError(form);
				return false;
			}
			form.trigger('submit');
		}
	}, 'input[type="submit"]');
}

function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}
function toggleActive(field) {
	var label = field.parent().siblings('label');
	label.toggleClass('active');
}
function generateError(form) {
	var errors = form.find('.error');
	var requiredFields = form.find('.gfield_contains_required').find('input');

	requiredFields.each(function (index, el) {
		if ($(this).val() === '') {
			$(this).addClass('error');
		}
	});
	if (errors) {
		// errors.each(function () {
		// 	console.log($(this));
		// });
	}
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export navIsOpen */
/* harmony export (immutable) */ __webpack_exports__["a"] = navigationEvents;
var menu = $('.c-lightbox'),
    btn = $('.menu-btn'),
    menuLink = $('.menu a');

var navIsOpen = false;
function navigationEvents() {
    $('body').on('click', btn, function (event) {
        var target = $(event.target);

        if (!navIsOpen && target.is(btn)) {
            toggle();
        }

        if (navIsOpen && !target.closest(menuLink).length && !target.is(btn)) {
            toggle();
        }
    }).on('keyup', function (event) {
        if (event.keyCode == 27 && navIsOpen) {
            toggle();
        }
    });
}
function toggle() {
    navIsOpen = !navIsOpen ? true : false;
    $('body').toggleClass('js-nav-open');
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_src_uncompressed_TweenMax__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_src_uncompressed_TweenMax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap_src_uncompressed_TweenMax__);
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollAnimation;
/* harmony export (immutable) */ __webpack_exports__["b"] = interiaScroll;



var raf = __webpack_require__(9);
var interiaItem = $('.js-interia-scroll');
var bgItem1 = $('.page-background.layer-one');
var bgItem2 = $('.page-background.layer-two');
__webpack_require__(10);

function scrollAnimation() {
	$('.scroll-indicator a').click(function (event) {
		event.preventDefault();
		var target = $('.row').eq(1);
		$('html, body').animate({
			scrollTop: target.offset().top
		}, 1600, 'swing');
	});
	setTimeout(function () {
		$('.waypoint').each(function () {
			var $element = $(this);
			var waypoints = new Waypoint({
				element: this,
				handler: function (direction) {
					var $el = $(this.element);

					if (direction == 'down') $el.addClass('waypoint-active');
					if (direction == 'up') $el.removeClass('waypoint-active');
				},
				offset: '92%'
			});
		});
		$('.waypoint-full').each(function () {
			var waypoints = new Waypoint({
				element: this,
				handler: function (direction) {
					var $el = $(this.element);

					if (direction == 'down') $el.addClass('waypoint-active');
					if (direction == 'up') {
						if (!$el.is('.c-header__img')) {
							$el.removeClass('waypoint-active');
						}
					}
				},
				offset: '110%'
			});
		});
	}, 1000);

	if (interiaItem) {
		interiaItem.each(function (index, el) {
			$(this).attr('data-offset', $(this).offset().top);
			$(this).attr('data-interia-speed', 0.4 * 0.2);

			if ($(this).parents('.row__image').find('img').height() < 250 && window.innerWidth <= 480) {
				$(this).parents('.row__image').css({
					'width': '80%'
				});
			}
			if ($(this).parents('.o-content').height() < 290 && window.innerWidth <= 480) {
				$(this).parents('.row').css({
					'min-height': '60vh'
				});
			}
		});
		$(window).on('resize', function () {
			interiaItem.each(function (index, el) {
				$(this).attr('data-offset', $(this).offset().top);
			});
		});
	}
}

function interiaScroll() {
	interiaItem.each(function (index, elem) {
		var range = $(this).data('offset') - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index_js__["scrollTop"])();
		var speed = $(this).data('interia-speed');
		__WEBPACK_IMPORTED_MODULE_1_gsap_src_uncompressed_TweenMax___default.a.to($(this), 1.5, {
			y: range * speed,
			skewY: 0,
			ease: Power4.easeOut
		}, 0);
	});
	if (!__WEBPACK_IMPORTED_MODULE_0__index_js__["isMobile"]) {
		var horizScrollPos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index_js__["scrollTop"])() * 0.15;
		var vertScrollPos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__index_js__["scrollTop"])() * 0.2;
		bgItem1.css('background-position', vertScrollPos + "px " + horizScrollPos + "px");
		bgItem2.css('background-position', -vertScrollPos + "px " + -horizScrollPos + "px");
	}
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)))

/***/ })
],[1]);


// WEBPACK FOOTER //
// app.js